import COIN_F from "@assets/coins/COIN_F.png";
import COIN_P from "@assets/coins/COIN_P.png";
import COIN_R from "@assets/coins/COIN_R.png";
import COIN_S from "@assets/coins/COIN_S.png";
import { Image, type ImageProps } from "@mantine/core";

export enum ECoinVariant {
  REWARDS = "rewards",
  FIDELITY = "fidelity",
  AFFILIATE = "affiliate",
  SECRET_SMURFS = "secret-smurfs",
}

interface ICoinsProps {
  variant?: ECoinVariant;
  size?: number;
}

const Coins: React.FC<ICoinsProps & ImageProps> = ({
  variant = ECoinVariant.SECRET_SMURFS,
  size = 20,
  ...rest
}) => {
  const coinVariants = {
    [ECoinVariant.AFFILIATE]: COIN_P,
    [ECoinVariant.FIDELITY]: COIN_F,
    [ECoinVariant.REWARDS]: COIN_R,
    [ECoinVariant.SECRET_SMURFS]: COIN_S,
  };

  return <Image src={coinVariants[variant]} h={size} w={size} {...rest} />;
};

export default Coins;
